export default __webpack_public_path__ + "static/bch-logo-3557fddc1d0b40e851f09a8d31b133cf.svg";